import { Badge2 } from "@/ui2/atoms/Badge";
import type { NoteAddendumState } from "@/core/types";

type Props = {
  state: NoteAddendumState;
};

export function AddendumStateBadge({ state }: Props) {
  switch (state) {
    case "rejected":
      return (
        <Badge2 appearance="outline" size="sm" variant="error">
          Returned
        </Badge2>
      );

    case "pending":

    case "resubmitted":
      return (
        <Badge2 appearance="outline" size="sm" variant="warning">
          Pending Co-Sign
        </Badge2>
      );

    default:
      return null;
  }
}
